import { createEvent } from './createEvent'

type DashboardPageViewedProperties = {
  fid: string
  siteName: string
}

export const dashboardPageViewed = createEvent<DashboardPageViewedProperties>(
  'Dashboard Page Viewed',
)

type ReviewAnomaliesClickedProperties = {
  fid: string
}

export const reviewAnomaliesClicked =
  createEvent<ReviewAnomaliesClickedProperties>('Review Anomalies Clicked')
